export const Role = {
    Manager: "Manager",
    Admin: 'Administrator',
    Supervisor: 'Supervisor',
    Seller: 'Seller',
    Donor: 'Donor'
}